function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import _ from 'lodash';
import gettext from 'js-utils/gettext';
import Icon from 'eventbrite_design_system/icon/Icon';
import { HAS_WINDOW } from 'eventbrite_design_system/utils/dom';
import { AUTOCOMPLETE_STORAGE_KEY, BROWSING_ONLINE_EVENTS_TEXT, LOCATION_STORAGE_KEY, HISTORY_SUGGESTIONS_SHOWN, SHORT_STATES, ONLINE_EVENTS_LOCATION_SLUG, SUGGESTION_TYPE_HISTORY } from '../constants';
import CheckChunkySvg from 'eventbrite_design_system/iconography/icons/CheckChunky';
import ClockSvg from 'eventbrite_design_system/iconography/icons/Clock';
import CrosshairSvg from 'eventbrite_design_system/iconography/icons/Crosshair';
import GlobeChunky from 'eventbrite_design_system/iconography/icons/GlobeChunky';
export var getOnlineEventsOption = function getOnlineEventsOption(onlineEventsContent) {
  return {
    slug: ONLINE_EVENTS_LOCATION_SLUG,
    currentPlace: BROWSING_ONLINE_EVENTS_TEXT.toString(),
    currentPlaceParent: '',
    latitude: null,
    longitude: null,
    value: ONLINE_EVENTS_LOCATION_SLUG,
    content: onlineEventsContent || gettext('Browse online events'),
    placeType: null,
    iconType: React.createElement(GlobeChunky, null),
    isOnline: true
  };
};
/*
 * @param item -- object -- ${item}: ${content, secondaryContent}
 *      - Object with the values to be shown as a list item
 * @param shouldShowCheck -- bool -- ${shouldShowCheck}: ${true|false}
 *      - Boolean variable to enable or disable the check on the list item
 *      - Default value: false.
 *
 * Function takes in two texts and a boolean variable and returns an html object with
 * a proper formatting and an optional check on the side.
 */

export var addCheckToSuggestion = function addCheckToSuggestion(_ref) {
  var _ref$item = _ref.item,
      content = _ref$item.content,
      secondaryContent = _ref$item.secondaryContent,
      _ref$shouldShowCheck = _ref.shouldShowCheck,
      shouldShowCheck = _ref$shouldShowCheck === void 0 ? false : _ref$shouldShowCheck;
  var currentLocationIcon = null;

  var _secondaryContent = React.createElement("div", {
    className: "eds-text-list-item__content-secondary"
  }, secondaryContent);

  if (shouldShowCheck) {
    currentLocationIcon = React.createElement(Icon, {
      type: React.createElement(CheckChunkySvg, null),
      size: "small",
      color: "vibrant-green"
    });
  }

  return React.createElement("div", {
    className: "eds-align--center-vertical eds-align--space-between"
  }, React.createElement("div", null, content, _secondaryContent), currentLocationIcon);
};
export var parseHistorySuggestions = function parseHistorySuggestions(_temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
      inputValue = _ref2.inputValue,
      place = _ref2.place,
      _ref2$storageKey = _ref2.storageKey,
      storageKey = _ref2$storageKey === void 0 ? AUTOCOMPLETE_STORAGE_KEY : _ref2$storageKey;

  var historySuggestions = [];

  try {
    if (HAS_WINDOW) {
      var searchHistory = localStorage.getItem(storageKey);

      if (!_.isEmpty(searchHistory)) {
        historySuggestions = searchHistory.split(',');
      }

      if (inputValue) {
        historySuggestions = historySuggestions.filter(function (value) {
          return value.toLowerCase().startsWith(inputValue.toLowerCase());
        });
      }
    }
  } catch (error) {
    // in production, we silently fail and drop the history feature
    if (process.env.NODE_ENV === 'development') {
      throw error;
    }
  }

  return _.chain(historySuggestions).map(function (value, index) {
    var itemValue = {
      value: value,
      content: value
    };

    if (storageKey === LOCATION_STORAGE_KEY) {
      itemValue = JSON.parse(value.replace(/;/g, ','));
      itemValue.content = addCheckToSuggestion({
        item: itemValue,
        shouldShowCheck: place && place === itemValue.content + itemValue.secondaryContent
      });
      itemValue.secondaryContent = null;
    }

    return _objectSpread({}, itemValue, {
      iconType: React.createElement(ClockSvg, null),
      header: index === 0 ? gettext('Recent') : null,
      showDivider: historySuggestions.length === index + 1 || index === 4,
      dividerVertSpacing: 2,
      suggestionType: SUGGESTION_TYPE_HISTORY
    });
  }).take(HISTORY_SUGGESTIONS_SHOWN).value();
};

var parseLocationSuggestions = function parseLocationSuggestions(_ref3) {
  var locationSuggestions = _ref3.locationSuggestions,
      _ref3$isTyping = _ref3.isTyping,
      isTyping = _ref3$isTyping === void 0 ? false : _ref3$isTyping,
      locationQuery = _ref3.locationQuery;
  var shouldShowHeader = !isTyping || !locationQuery;
  return _.chain(locationSuggestions).map(function (value, index) {
    return _objectSpread({}, value, {
      header: index === 0 && shouldShowHeader ? gettext('Popular') : null
    });
  }).value();
};

var parseInitialLocationSuggestions = function parseInitialLocationSuggestions(_ref4) {
  var currentPlace = _ref4.currentPlace,
      currentPlaceParent = _ref4.currentPlaceParent,
      isUseCurrentLocationEnabled = _ref4.isUseCurrentLocationEnabled,
      isOnlineEventsEnabled = _ref4.isOnlineEventsEnabled,
      locationSuggestions = _ref4.suggestions,
      usingCurrentLocation = _ref4.usingCurrentLocation,
      isOnline = _ref4.isOnline;

  var _suggestions = parseLocationSuggestions({
    locationSuggestions: locationSuggestions
  });

  var historySuggestions = parseHistorySuggestions({
    place: currentPlace + currentPlaceParent,
    storageKey: LOCATION_STORAGE_KEY
  });
  var useCurrentLocation = [];
  var browseOnlineEvents = [];

  if (isUseCurrentLocationEnabled) {
    var currentPlaceSecondaryContent = '';
    var shouldShowCheck = false;

    if (usingCurrentLocation) {
      currentPlaceSecondaryContent = currentPlace;
      shouldShowCheck = true;
    }

    var currentLocationContent = addCheckToSuggestion({
      item: {
        content: gettext('Use my current location'),
        secondaryContent: currentPlaceSecondaryContent
      },
      shouldShowCheck: shouldShowCheck
    });
    var currentLocationOption = {
      value: '',
      content: currentLocationContent,
      iconType: React.createElement(CrosshairSvg, null)
    };
    useCurrentLocation = [currentLocationOption];
  }

  if (isOnlineEventsEnabled) {
    var _shouldShowCheck = isOnline;
    var onlineEventsContent = addCheckToSuggestion({
      item: {
        content: gettext('Browse online events'),
        secondaryContent: ''
      },
      shouldShowCheck: _shouldShowCheck
    });
    var onlineEventsOption = getOnlineEventsOption(onlineEventsContent);
    browseOnlineEvents = [onlineEventsOption];
  }

  _suggestions = [].concat(useCurrentLocation, browseOnlineEvents, historySuggestions, _suggestions);
  return _suggestions;
};

export var getLocationSuggestions = function getLocationSuggestions(_ref5, isUseCurrentLocationEnabled, isOnlineEventsEnabled) {
  var suggestions = _ref5.suggestions,
      topSuggestions = _ref5.topSuggestions,
      currentPlace = _ref5.currentPlace,
      currentPlaceParent = _ref5.currentPlaceParent,
      _ref5$usingCurrentLoc = _ref5.usingCurrentLocation,
      usingCurrentLocation = _ref5$usingCurrentLoc === void 0 ? false : _ref5$usingCurrentLoc,
      _ref5$isOnline = _ref5.isOnline,
      isOnline = _ref5$isOnline === void 0 ? false : _ref5$isOnline;

  if (isUseCurrentLocationEnabled === void 0) {
    isUseCurrentLocationEnabled = false;
  }

  if (isOnlineEventsEnabled === void 0) {
    isOnlineEventsEnabled = false;
  }

  if (_.isEmpty(suggestions)) {
    return {
      suggestions: parseInitialLocationSuggestions({
        currentPlace: currentPlace,
        currentPlaceParent: currentPlaceParent,
        isUseCurrentLocationEnabled: isUseCurrentLocationEnabled,
        isOnlineEventsEnabled: isOnlineEventsEnabled,
        suggestions: topSuggestions,
        usingCurrentLocation: usingCurrentLocation,
        isOnline: isOnline
      }),
      hasSuggestions: false
    };
  }

  return {
    suggestions: suggestions,
    hasSuggestions: true
  };
}; //Helper to below which returns the
//abbreviated region if it should

var _getAbbreviatedRegion = function _getAbbreviatedRegion(region) {
  var abbreviated;

  if (region) {
    abbreviated = SHORT_STATES[region.toLowerCase()];
  }

  return abbreviated ? abbreviated : region;
}; // Util which parses response from the Location Autocomplete Endpoint
// into a format the LocationAutocomplete and our store understands


export var parseLocationResponse = function parseLocationResponse(_ref6, featureFlags) {
  var places = _ref6.places;
  var enabledPlaces = ['locality', 'borough'];

  if (featureFlags && featureFlags.isRegionAndCountrySearchEnabled) {
    enabledPlaces = [].concat(enabledPlaces, ['region', 'country']);
  }

  return _.chain(places).filter(function (_ref7) {
    var placeType = _ref7.place_type;
    return enabledPlaces.includes(placeType);
  }).map(function (_ref8) {
    var id = _ref8.id,
        slug = _ref8.slug,
        name = _ref8.name,
        subtitle = _ref8.subtitle,
        latitude = _ref8.latitude,
        longitude = _ref8.longitude,
        bbox = _ref8.bbox,
        placeType = _ref8['place_type'];
    return {
      slug: slug,
      placeType: placeType,
      currentPlace: name,
      currentPlaceParent: _getAbbreviatedRegion(subtitle),
      latitude: latitude ? parseFloat(latitude) : '',
      longitude: longitude ? parseFloat(longitude) : '',
      bbox: bbox,
      value: id,
      content: name,
      secondaryContent: subtitle
    };
  }).value();
};